import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Settings|Roles|Create|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsRolesCreate';
export type SPSettingsRolesCreateLocNames =
	| `${LocNameStart}NotificationPermissionsRequired`
	| `${LocNameStart}NotificationNameRequired`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonCancelCreate`
	| `${LocNameStart}ButtonCopyPermissions`
	| `${LocNameStart}ButtonCreateRole`
	| `${LocNameStart}LabelRoleName`
	| `${LocNameStart}ErrorRoleNameRequired`
	| `${LocNameStart}ErrorRoleNameMaxLength`
	| `${LocNameStart}ErrorRoleNameOnlySpaces`;

export const spSettingsRolesCreateLocs: LocDefs<SPSettingsRolesCreateLocNames> = {
	SPSettingsRolesCreateNotificationPermissionsRequired: {
		defaultValue: 'At least one permission is required',
		description: 'Error message when trying to save a role without any permissions selected',
		displayPath: `${pathStart}Permissions required`,
		displayType: 'Notification',
		legacyName: 'Core/Settings.Roles.Notification.PermissionsRequired',
		...sharedProperties,
	},
	SPSettingsRolesCreateNotificationNameRequired: {
		defaultValue: 'A role name is required',
		description: 'Error message when trying to save a role without a name entered',
		displayPath: `${pathStart}Name Required`,
		displayType: 'Notification',
		legacyName: 'Core/Settings.Roles.Notification.NameRequired',
		...sharedProperties,
	},
	SPSettingsRolesCreateTitleSection: {
		defaultValue: 'Create a New Role',
		description: 'Section Title',
		displayPath: `${pathStart}Section Title`,
		displayType: 'Title',
		legacyName: 'Core/Settings.Roles.Title.CreateSection',
		...sharedProperties,
	},
	SPSettingsRolesCreateButtonCancelCreate: {
		defaultValue: 'Cancel',
		description: 'Cancel button text for the create role form',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.CancelCreate',
		...sharedProperties,
	},
	SPSettingsRolesCreateButtonCopyPermissions: {
		defaultValue: 'Copy Permissions from Another Role',
		description: 'Copy permissions button text for the create role form',
		displayPath: `${pathStart}Copy Permissions`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.CopyRoleCreate',
		...sharedProperties,
	},
	SPSettingsRolesCreateButtonCreateRole: {
		defaultValue: 'Create Role',
		description: 'Create Role button',
		displayPath: `${pathStart}Create Role`,
		displayType: 'Button',
		legacyName: 'Core/Settings.Roles.Button.SaveCreate',
		...sharedProperties,
	},
	SPSettingsRolesCreateLabelRoleName: {
		defaultValue: 'Role Name',
		description: 'Label for: Role Name.',
		displayPath: `${pathStart}Role Name`,
		displayType: 'Label',
		legacyName: 'Core/Settings.Roles.FieldLabel.RoleName',
		...sharedProperties,
	},
	SPSettingsRolesCreateErrorRoleNameRequired: {
		defaultValue: 'A role name is required',
		description: 'Role Name required error.',
		displayPath: `${pathStart}Role Name Required`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.NameRequired',
		...sharedProperties,
	},
	SPSettingsRolesCreateErrorRoleNameMaxLength: {
		defaultValue: 'A role name cannot be longer than 50 characters',
		description: 'Role Name max length error.',
		displayPath: `${pathStart}Role Name Max Length`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.NameMaxLength',
		...sharedProperties,
	},
	SPSettingsRolesCreateErrorRoleNameOnlySpaces: {
		defaultValue: 'The role name must not contain only spaces',
		description: 'Role Name cannot contain only spaces error.',
		displayPath: `${pathStart}Role Name Only Spaces`,
		displayType: 'Error',
		legacyName: 'Core/Settings.Roles.FieldError.OnlySpaces',
		...sharedProperties,
	},
};

export type SPSettingsRolesCreateLocType = LocMap<SPSettingsRolesCreateLocNames>;
